import { useQuery } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	getPortfolioV2,
	type PortfolioReportingOverviewTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePortfolioListQuery = (
	filterDatagroups?: PortfolioReportingOverviewTypeEnum[],
	filterOnlyreportingenabled?: boolean,
	enabled = true,
) => {
	return useQuery({
		queryKey: PortfolioKeys.portfolioList(
			filterDatagroups,
			filterOnlyreportingenabled,
		),
		queryFn: ({ signal }) =>
			processResponse(() =>
				getPortfolioV2(filterDatagroups, filterOnlyreportingenabled, {
					signal,
				}),
			)(undefined),
		enabled,
	});
};
